export const config = {
    version: '1.1.168',
    appInsightsInstrumentationKey: {
        local: 'c707324b-43b3-41e5-957d-522f3f386d97',
        dev: '495066b0-9ebb-4ee7-986a-08189888a108',
        stage: 'fcf754d4-fdda-4d0d-9ba3-6b2d03c8e718',
        prod: '279e92e2-6e2a-4c5e-97d5-53e274c9a710',
        prodeu: '4a17e4ae-0f25-44a3-87fc-2d38cc8f2acd',
    }
};
